module.exports = __webpack_public_path__ + "images/home-and-contents.ff2ae26075b5bdd80fd2c6185d58856a.svg";